// extracted by mini-css-extract-plugin
export default {"root":"BackToRoot__root--26t4U","icon":"BackToRoot__icon--2Xibh","label":"BackToRoot__label--261N3"};